import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueI18n from "vue-i18n";
import VTooltip from "v-tooltip";
import en from "@/locales/en";
import nl from "@/locales/nl";

Vue.config.productionTip = false;

var options = {
  'defaultTrigger': 'hover focus click',
  'autoHide': 'false'
}
Vue.use(VueI18n);
Vue.use(VTooltip, options);

export const i18n = new VueI18n({
  locale: new URLSearchParams(window.location.search).get('locale') === null
    ? "en"
    : new URLSearchParams(window.location.search).get('locale'),
  messages: {
    en: { ...en },
    nl: { ...nl }
  }
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
